export default "__VITE_ASSET__DsgNfQAi__"